var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWaveSine(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M638.641 297.188C633.017 315.906 580.441 480 463.993 480C346.404 480 294.485 285.906 288.954 263.75C275.189 209.031 229.457 96 176.006 96C117.087 96 73.339 197.594 62.667 233.188C57.574 250.125 39.746 259.719 22.825 254.656C5.889 249.562 -3.72 231.719 1.357 214.812C6.982 196.094 59.558 32 176.006 32C293.594 32 345.514 226.094 351.045 248.25C364.81 302.969 410.542 416 463.993 416C522.912 416 566.66 314.406 577.332 278.812C582.441 261.875 600.299 252.375 617.174 257.344C634.11 262.438 643.719 280.281 638.641 297.188Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaveSine);
export default __webpack_public_path__ + "static/media/wave-sine.308a2ea42e90f29c172cd64f1af58aca.svg";
export { ForwardRef as ReactComponent };